import { useEffect, useState } from "react";
import Button from "../../../button/button";
import InputAnimated from "../../../inputAnimated/inputAnimated";
import Modal from "../../../modal/modal";
import Select from "../../../select/select";
import './AddStock.scss';
import { GetLevelListV2, PostAddBookStock } from "../../../../utils/Apis/apis";

const AddStock = ({ onClose, isOpen, cacheBooks, showAlert }) => {
    const [stockQty, setStockQty] = useState('');
    const [selectedArticle, setSelectedArticle] = useState('3')
    const [selectedBookType, setSelectedBookType] = useState('');
    const [selectedBook, setSelectedBook] = useState('');
    const [quantityState, setQuantityState] = useState('')
    const [listState, setListState] = useState({
        bookAdults: [],
        bookKids: []
    });

    const articles = [{ value: '3', label: 'Libro' }];
    const bookType = [
        { value: 1, label: 'Adultos' },
        { value: 2, label: 'Niños' }
    ];


    useEffect(() => {
        const controller = new AbortController();

        const fetchData = async () => {
            // 📦 Verificar si ya existe en caché
            if (cacheBooks.current['books']) {
                const cached = cacheBooks.current['books'];
                setListState({
                    bookAdults: cached.adults || [],
                    bookKids: cached.kids || []
                });
                return;
            }

            try {
                const books = await GetLevelListV2();
                if (controller.signal.aborted) return;
                if (books.status === 200 && books.result) {
                    // 🧠 Guardar en caché
                    cacheBooks.current['books'] = books.result;

                    setListState({
                        bookAdults: books.result.adults || [],
                        bookKids: books.result.kids || []
                    });
                }
            } catch (error) {
                console.error("❌ Error al cargar libros", error);
            }
        };

        fetchData();

        return () => {
            controller.abort(); // cancelar si desmonta
        };
    }, []);


    // Opciones dinámicas de libros según tipo
    const bookOptions = selectedBookType === 1
        ? listState.bookAdults.map(book => ({
            value: book.id,
            label: `${book.name}`,
            book
        }))
        : selectedBookType === 2
            ? listState.bookKids.map(book => ({
                value: book.id,
                label: `${book.name}`,
                book
            }))
            : [];

    const handleAddArticlesStock = async () => {
        if (!quantityState || !selectedBook) {
            return showAlert('info', 'Falta cantidad o libro');
        }

        const postAddBook = await PostAddBookStock(selectedBook, quantityState);
        if (postAddBook.status === 200) {
            showAlert('success', postAddBook.message)
            // Obtener libro original para saber su tipo
            const allBooks = [...listState.bookAdults, ...listState.bookKids];
            const originalBook = allBooks.find(b => b.id === selectedBook);
            if (!originalBook) return;

            const newStock = parseInt(originalBook.stock || 0) + parseInt(quantityState);
            const updatedBook = { ...originalBook, stock: newStock };

            // 🔁 Actualiza el listState
            setListState((prev) => {
                const updateList = (list) =>
                    list.map(book => (book.id === selectedBook ? updatedBook : book));

                return {
                    bookAdults: originalBook.type_id === 1 ? updateList(prev.bookAdults) : prev.bookAdults,
                    bookKids: originalBook.type_id === 2 ? updateList(prev.bookKids) : prev.bookKids
                };
            });

            // 🧠 Actualiza caché si existe
            const cache = cacheBooks.current['books'];
            if (cache) {
                const updateList = (list) =>
                    list.map(book => (book.id === selectedBook ? updatedBook : book));

                if (originalBook.type_id === 1) {
                    cache.adults = updateList(cache.adults);
                } else {
                    cache.kids = updateList(cache.kids);
                }
            }

            // Actualiza el stock mostrado
            setStockQty(newStock.toString());
            setQuantityState('');
        }
    };



    return (
        <Modal onClose={onClose} isOpen={isOpen} overlayClick={false}>
            <div className="add-stock-contain">
                <h1 className="title-1">Agregar artículos a inventario</h1>

                {/* Tipo de artículo fijo */}
                <Select options={articles} placeholder={'Artículo'} value={selectedArticle} disabled={true} />

                {/* Tipo de libro */}
                <Select
                    options={bookType}
                    placeholder={'Selecciona tipo de libro'}
                    value={selectedBookType}
                    onChange={(e) => {
                        const value = parseInt(e.target?.value || e.value); // según el Select que uses
                        setSelectedBookType(value);
                        setSelectedBook(''); // Limpiar selección previa
                        setQuantityState('')
                    }}
                />

                {/* Libros disponibles según el tipo */}
                {selectedBookType && (
                    <Select
                        options={bookOptions}
                        placeholder={'Selecciona un libro'}
                        value={selectedBook}
                        onChange={(e) => {
                            const bookId = parseInt(e.target?.value || e.value);
                            const found = bookOptions.find(opt => opt.value === bookId);
                            setSelectedBook(found?.value || null);
                            setStockQty(found?.book?.stock?.toString() || '0');
                            setQuantityState('')
                        }}
                    />
                )}

                <InputAnimated
                    placeholder="Cantidad a agregar"
                    type="text"
                    value={quantityState}
                    onChange={(e) => {
                        const value = e.target.value;

                        // Solo números enteros positivos
                        if (/^\d*$/.test(value)) {
                            setQuantityState(value);
                        }
                    }}
                    onKeyDown={(e) => {
                        // Bloquear caracteres no numéricos: e.preventDefault() en +, -, ., e, etc.
                        if (
                            ['e', 'E', '+', '-', '.'].includes(e.key)
                        ) {
                            e.preventDefault();
                        }
                    }}
                    inputMode="numeric" // Muestra teclado numérico en móviles
                />

                <h1 className="title-2">Inventario actual: <span className="stock-qty">{stockQty}</span> </h1>

                <div className="confirm-buttons-section">
                    <Button backgroundColor="red" text="Cancelar" onClick={onClose} />
                    <Button backgroundColor="blue" text="Confirmar" onClick={handleAddArticlesStock} />
                </div>
            </div>
        </Modal>
    );
};

export default AddStock;